import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { CoreModule } from '@c4/core';
import { AuthModule } from '@c4/auth';
import { UIModule } from '@c4/ui';
import { AssetsModule } from '@c4/assets';

import { StoreModule } from '@ngrx/store';

import { SysmanRoutesModule } from './app.routes';
import { SYSMAN_PROVIDERS } from './app.providers';

import { SysmanComponentBase } from './sysman/sysman.component';
import { SysmanComponent } from './sysman/sysman.component';
import { SysmanSddpDiscoveryComponent } from './sysman-sddp-discovery/sysman-sddp-discovery.component';
import { SysmanNetworkConfigComponent } from './sysman-network-config/sysman-network-config.component';
import { SysmanLogConfigComponent } from './sysman-log-config/sysman-log-config.component';
import { SysmanProcessStatusComponent } from './sysman-process-status/sysman-process-status.component';
import { SysmanSddpDeviceDetailComponent } from './sysman-sddp-device-detail/sysman-sddp-device-detail.component';
import { SysmanLogViewComponent } from './sysman-log-view/sysman-log-view.component';
import { SysmanVpnConfigComponent } from './sysman-vpn-config/sysman-vpn-config.component';
import { SysmanTimeConfigComponent } from './sysman-time-config/sysman-time-config.component';
import { SysmanPackageVersionsComponent } from './sysman-package-versions/sysman-package-versions.component';
import { SysmanConnectedComponent } from './sysman-connected/sysman-connected.component';
import { SysmanMenuComponent } from './sysman-menu/sysman-menu.component';
import { SysmanOutputComponent } from './sysman-output/sysman-output.component';
import { ListSelectorComponent } from './list-selector/list-selector';
import { SysmanNetworkConfigDomainComponent } from './sysman-network-config/domain-config.component';
import { SysmanNetworkConfigDNSComponent } from './sysman-network-config/dns-config.component';
import { SysmanNetworkConfigIPComponent } from './sysman-network-config/ip-config.component';
import { AppComponent } from './app.component';

import {
  ListFilterPipe, LogDisplayPipe, ActiveMenuItemsPipe, DatexPipe
} from './pipes/index';

@NgModule({
  imports: [
    // --- angular
    BrowserModule,
    FormsModule,
    HttpModule,
    CommonModule,
    // --- router
    RouterModule,
    // --- @ngrx
    StoreModule,
    // --- c4-framework
    CoreModule,
    AuthModule,
    UIModule,
    AssetsModule,
    SysmanRoutesModule
  ],
  declarations: [
    // components
    AppComponent,
    SysmanComponent,
    SysmanSddpDiscoveryComponent,
    SysmanNetworkConfigComponent,
    SysmanLogConfigComponent,
    SysmanProcessStatusComponent,
    SysmanSddpDeviceDetailComponent,
    SysmanLogViewComponent,
    SysmanVpnConfigComponent,
    SysmanTimeConfigComponent,
    SysmanOutputComponent,
    SysmanPackageVersionsComponent,
    SysmanConnectedComponent,
    SysmanMenuComponent,
    ListSelectorComponent,
    SysmanNetworkConfigDomainComponent,
    SysmanNetworkConfigDNSComponent,
    SysmanNetworkConfigIPComponent,
    // pipes
    ListFilterPipe,
    LogDisplayPipe,
    ActiveMenuItemsPipe,
    DatexPipe
  ],
  providers: [
    ...SYSMAN_PROVIDERS
  ],
  exports: [
    SysmanComponent
  ],
  bootstrap: [AppComponent]
})
export class SysmanModule { }



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/app.module.ts